// Mock data for Trove Investment Platform

export const stats = {
  aum: '$1.1B',
  cagr: '10.7%',
  awards: '10',
  fee: '1.2%',
  minimum: '$500'
};

export const investmentStrategies = [
  {
    id: 'bedrock',
    name: 'Bedrock',
    category: 'Conservative',
    description: 'Wealth preservation with moderate growth through a defensive allocation focused on fixed income and credit strategies.',
    targetReturn: '6-8%',
    performance: '+7.2%',
    liquidity: '70%',
    minInvestment: 500,
    fee: 0.8,
    successFee: '10% of returns above 6%',
    riskLevel: 'Conservative',
    icon: 'Shield',
    totalAssets: 380000000,
    allocation: [
      { category: 'Gov/Corp Bonds', percentage: 45 },
      { category: 'Private Credit', percentage: 25 },
      { category: 'RE Debt', percentage: 15 },
      { category: 'Cash & Equivalents', percentage: 15 }
    ],
    detailedHoldings: [
      { symbol: 'AGG', name: 'iShares Core U.S. Aggregate Bond', allocation: 15.0, value: 57000000, shares: 550000, price: 103.64, change: 0.12, sector: 'Fixed Income', assetClass: 'Gov/Corp Bonds' },
      { symbol: 'LQD', name: 'iShares iBoxx Investment Grade Corporate', allocation: 12.0, value: 45600000, shares: 400000, price: 114.00, change: 0.08, sector: 'Fixed Income', assetClass: 'Gov/Corp Bonds' },
      { symbol: 'TLT', name: 'iShares 20+ Year Treasury Bond', allocation: 10.0, value: 38000000, shares: 420000, price: 90.48, change: -0.15, sector: 'Fixed Income', assetClass: 'Gov/Corp Bonds' },
      { symbol: 'MUB', name: 'iShares National Muni Bond', allocation: 8.0, value: 30400000, shares: 290000, price: 104.83, change: 0.05, sector: 'Fixed Income', assetClass: 'Gov/Corp Bonds' },
      { symbol: 'PCRD-A', name: 'Ares Private Credit Fund', allocation: 12.0, value: 45600000, shares: 456000, price: 100.00, change: 0.25, sector: 'Private Credit', assetClass: 'Private Credit' },
      { symbol: 'OCSL', name: 'Oaktree Specialty Lending', allocation: 8.0, value: 30400000, shares: 1800000, price: 16.89, change: 0.18, sector: 'Private Credit', assetClass: 'Private Credit' },
      { symbol: 'BXSL', name: 'Blackstone Secured Lending', allocation: 5.0, value: 19000000, shares: 650000, price: 29.23, change: 0.22, sector: 'Private Credit', assetClass: 'Private Credit' },
      { symbol: 'MORT', name: 'VanEck Mortgage REIT Income', allocation: 8.0, value: 30400000, shares: 780000, price: 38.97, change: 0.10, sector: 'Real Estate', assetClass: 'RE Debt' },
      { symbol: 'REM', name: 'iShares Mortgage Real Estate', allocation: 7.0, value: 26600000, shares: 980000, price: 27.14, change: 0.08, sector: 'Real Estate', assetClass: 'RE Debt' },
      { symbol: 'SGOV', name: 'iShares 0-3 Month Treasury', allocation: 10.0, value: 38000000, shares: 1480000, price: 25.68, change: 0.01, sector: 'Fixed Income', assetClass: 'Cash & Equivalents' },
      { symbol: 'BIL', name: 'SPDR Bloomberg 1-3 Month T-Bill', allocation: 5.0, value: 19000000, shares: 207000, price: 91.79, change: 0.01, sector: 'Fixed Income', assetClass: 'Cash & Equivalents' }
    ]
  },
  {
    id: 'fortress',
    name: 'Fortress',
    category: 'Defensive',
    description: 'Wealth preservation with moderate growth through diversified allocation across fixed income, real estate, and selective equities.',
    targetReturn: '8-10%',
    performance: '+9.1%',
    liquidity: '60%',
    minInvestment: 500,
    fee: 0.8,
    successFee: '15% of returns above 8%',
    riskLevel: 'Defensive',
    icon: 'Lock',
    totalAssets: 420000000,
    allocation: [
      { category: 'Fixed Income', percentage: 35 },
      { category: 'Real Estate', percentage: 20 },
      { category: 'Equities', percentage: 20 },
      { category: 'Alternatives', percentage: 15 },
      { category: 'Cash', percentage: 10 }
    ],
    detailedHoldings: [
      { symbol: 'BND', name: 'Vanguard Total Bond Market', allocation: 15.0, value: 63000000, shares: 780000, price: 80.77, change: 0.10, sector: 'Fixed Income', assetClass: 'Fixed Income' },
      { symbol: 'VCIT', name: 'Vanguard Intermediate-Term Corp', allocation: 10.0, value: 42000000, shares: 510000, price: 82.35, change: 0.08, sector: 'Fixed Income', assetClass: 'Fixed Income' },
      { symbol: 'TIP', name: 'iShares TIPS Bond ETF', allocation: 10.0, value: 42000000, shares: 380000, price: 110.53, change: 0.12, sector: 'Fixed Income', assetClass: 'Fixed Income' },
      { symbol: 'VNQ', name: 'Vanguard Real Estate ETF', allocation: 10.0, value: 42000000, shares: 480000, price: 87.50, change: 0.45, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'REIT-PE1', name: 'Blackstone Real Estate Fund', allocation: 10.0, value: 42000000, shares: 420000, price: 100.00, change: 0.35, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'VTI', name: 'Vanguard Total Stock Market', allocation: 10.0, value: 42000000, shares: 180000, price: 233.33, change: 0.85, sector: 'Equities', assetClass: 'Equities' },
      { symbol: 'SCHD', name: 'Schwab U.S. Dividend Equity', allocation: 10.0, value: 42000000, shares: 550000, price: 76.36, change: 0.52, sector: 'Equities', assetClass: 'Equities' },
      { symbol: 'IAU', name: 'iShares Gold Trust', allocation: 8.0, value: 33600000, shares: 720000, price: 46.67, change: 0.25, sector: 'Commodities', assetClass: 'Alternatives' },
      { symbol: 'DBC', name: 'Invesco DB Commodity Index', allocation: 7.0, value: 29400000, shares: 1200000, price: 24.50, change: -0.15, sector: 'Commodities', assetClass: 'Alternatives' },
      { symbol: 'SGOV', name: 'iShares 0-3 Month Treasury', allocation: 10.0, value: 42000000, shares: 1635000, price: 25.69, change: 0.01, sector: 'Fixed Income', assetClass: 'Cash' }
    ]
  },
  {
    id: 'horizon',
    name: 'Horizon',
    category: 'Balanced',
    description: 'Balance between growth and income with diversified exposure to equities, private equity, real estate, and fixed income.',
    targetReturn: '10-12%',
    performance: '+11.3%',
    liquidity: '50%',
    minInvestment: 500,
    fee: 1.2,
    successFee: '15% of returns above 10%',
    riskLevel: 'Moderate',
    icon: 'Compass',
    totalAssets: 550000000,
    allocation: [
      { category: 'Equities', percentage: 35 },
      { category: 'Private Equity', percentage: 15 },
      { category: 'Real Estate', percentage: 15 },
      { category: 'Fixed Income', percentage: 15 },
      { category: 'Alternatives', percentage: 20 }
    ],
    detailedHoldings: [
      { symbol: 'SPY', name: 'SPDR S&P 500 ETF', allocation: 12.0, value: 66000000, shares: 140000, price: 471.43, change: 1.25, sector: 'Equities', assetClass: 'Equities' },
      { symbol: 'QQQ', name: 'Invesco QQQ Trust', allocation: 10.0, value: 55000000, shares: 130000, price: 423.08, change: 1.85, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'VEA', name: 'Vanguard FTSE Developed Markets', allocation: 8.0, value: 44000000, shares: 920000, price: 47.83, change: 0.65, sector: 'International', assetClass: 'Equities' },
      { symbol: 'IWM', name: 'iShares Russell 2000', allocation: 5.0, value: 27500000, shares: 135000, price: 203.70, change: 1.15, sector: 'Small Cap', assetClass: 'Equities' },
      { symbol: 'PE-FUND1', name: 'KKR Global Impact Fund', allocation: 8.0, value: 44000000, shares: 440000, price: 100.00, change: 1.50, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'PE-FUND2', name: 'Apollo Growth Equity Fund', allocation: 7.0, value: 38500000, shares: 385000, price: 100.00, change: 1.35, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'VNQ', name: 'Vanguard Real Estate ETF', allocation: 8.0, value: 44000000, shares: 505000, price: 87.13, change: 0.55, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'REIT-PE2', name: 'Starwood Real Estate Fund', allocation: 7.0, value: 38500000, shares: 385000, price: 100.00, change: 0.45, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'AGG', name: 'iShares Core U.S. Aggregate Bond', allocation: 10.0, value: 55000000, shares: 530000, price: 103.77, change: 0.10, sector: 'Fixed Income', assetClass: 'Fixed Income' },
      { symbol: 'VCIT', name: 'Vanguard Intermediate-Term Corp', allocation: 5.0, value: 27500000, shares: 335000, price: 82.09, change: 0.08, sector: 'Fixed Income', assetClass: 'Fixed Income' },
      { symbol: 'GLD', name: 'SPDR Gold Shares', allocation: 8.0, value: 44000000, shares: 230000, price: 191.30, change: 0.35, sector: 'Commodities', assetClass: 'Alternatives' },
      { symbol: 'PDBC', name: 'Invesco Optimum Yield Diversified', allocation: 6.0, value: 33000000, shares: 2000000, price: 16.50, change: -0.25, sector: 'Commodities', assetClass: 'Alternatives' },
      { symbol: 'INFRA', name: 'Infrastructure Fund', allocation: 6.0, value: 33000000, shares: 330000, price: 100.00, change: 0.75, sector: 'Infrastructure', assetClass: 'Alternatives' }
    ]
  },
  {
    id: 'velocity',
    name: 'Velocity',
    category: 'Growth',
    description: 'Capital appreciation with moderate risk through substantial equity exposure complemented by private equity and venture capital investments.',
    targetReturn: '12-15%',
    performance: '+13.8%',
    liquidity: '40%',
    minInvestment: 500,
    fee: 1.2,
    successFee: '20% of returns above 12%',
    riskLevel: 'Moderate-High',
    icon: 'TrendingUp',
    totalAssets: 680000000,
    allocation: [
      { category: 'Equities', percentage: 40 },
      { category: 'Private Equity', percentage: 20 },
      { category: 'Venture Capital', percentage: 15 },
      { category: 'Real Estate', percentage: 10 },
      { category: 'Alternatives', percentage: 15 }
    ],
    detailedHoldings: [
      { symbol: 'NVDA', name: 'Nvidia Corporation', allocation: 6.0, value: 40800000, shares: 90000, price: 453.33, change: 2.45, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'MSFT', name: 'Microsoft Corporation', allocation: 5.5, value: 37400000, shares: 98000, price: 381.63, change: 1.35, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'AAPL', name: 'Apple Inc.', allocation: 5.0, value: 34000000, shares: 180000, price: 188.89, change: 0.85, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'AMZN', name: 'Amazon.com Inc.', allocation: 4.5, value: 30600000, shares: 175000, price: 174.86, change: 1.55, sector: 'Consumer Cyclical', assetClass: 'Equities' },
      { symbol: 'GOOGL', name: 'Alphabet Inc.', allocation: 4.0, value: 27200000, shares: 195000, price: 139.49, change: 1.25, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'META', name: 'Meta Platforms Inc.', allocation: 4.0, value: 27200000, shares: 59000, price: 461.02, change: 2.15, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'TSLA', name: 'Tesla Inc.', allocation: 3.5, value: 23800000, shares: 115000, price: 206.96, change: 1.85, sector: 'Consumer Cyclical', assetClass: 'Equities' },
      { symbol: 'QQQ', name: 'Invesco QQQ Trust', allocation: 7.5, value: 51000000, shares: 120000, price: 425.00, change: 1.45, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'PE-TECH1', name: 'Sequoia Capital Growth Fund', allocation: 10.0, value: 68000000, shares: 680000, price: 100.00, change: 1.85, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'PE-TECH2', name: 'Thoma Bravo Fund XV', allocation: 10.0, value: 68000000, shares: 680000, price: 100.00, change: 1.65, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'VC-SEED1', name: 'Andreessen Horowitz Fund VII', allocation: 8.0, value: 54400000, shares: 544000, price: 100.00, change: 2.25, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'VC-EARLY1', name: 'Accel Growth Fund IV', allocation: 7.0, value: 47600000, shares: 476000, price: 100.00, change: 1.95, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'VNQ', name: 'Vanguard Real Estate ETF', allocation: 6.0, value: 40800000, shares: 470000, price: 86.81, change: 0.65, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'REIT-TECH', name: 'Data Centre REIT Fund', allocation: 4.0, value: 27200000, shares: 272000, price: 100.00, change: 1.15, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'CRYPTO-1', name: 'Crypto Index Fund', allocation: 8.0, value: 54400000, shares: 544000, price: 100.00, change: 3.50, sector: 'Digital Assets', assetClass: 'Alternatives' },
      { symbol: 'INFRA-TECH', name: 'Tech Infrastructure Fund', allocation: 7.0, value: 47600000, shares: 476000, price: 100.00, change: 1.25, sector: 'Infrastructure', assetClass: 'Alternatives' }
    ]
  },
  {
    id: 'summit',
    name: 'Summit',
    category: 'Aggressive',
    description: 'Maximum growth potential through aggressive allocation to equities, venture capital, and private equity with concentrated positions.',
    targetReturn: '15-18%',
    performance: '+16.5%',
    liquidity: '35%',
    minInvestment: 500,
    fee: 1.5,
    successFee: '20% of returns above 15%',
    riskLevel: 'Aggressive',
    icon: 'Zap',
    totalAssets: 520000000,
    allocation: [
      { category: 'Equities', percentage: 35 },
      { category: 'Venture Capital', percentage: 25 },
      { category: 'Private Equity', percentage: 20 },
      { category: 'Real Estate', percentage: 10 },
      { category: 'Alternatives', percentage: 10 }
    ],
    detailedHoldings: [
      { symbol: 'NVDA', name: 'Nvidia Corporation', allocation: 8.0, value: 41600000, shares: 91500, price: 454.65, change: 3.25, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'TSLA', name: 'Tesla Inc.', allocation: 6.5, value: 33800000, shares: 163000, price: 207.36, change: 2.85, sector: 'Consumer Cyclical', assetClass: 'Equities' },
      { symbol: 'PLTR', name: 'Palantir Technologies', allocation: 5.0, value: 26000000, shares: 925000, price: 28.11, change: 4.15, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'CRWD', name: 'CrowdStrike Holdings', allocation: 4.5, value: 23400000, shares: 75000, price: 312.00, change: 2.95, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'SNOW', name: 'Snowflake Inc.', allocation: 4.0, value: 20800000, shares: 144000, price: 144.44, change: 3.65, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'COIN', name: 'Coinbase Global Inc.', allocation: 3.5, value: 18200000, shares: 94000, price: 193.62, change: 5.25, sector: 'Financial Services', assetClass: 'Equities' },
      { symbol: 'ARKK', name: 'ARK Innovation ETF', allocation: 3.5, value: 18200000, shares: 380000, price: 47.89, change: 2.45, sector: 'Innovation', assetClass: 'Equities' },
      { symbol: 'VC-AI1', name: 'AI Seed Fund (Tier 1)', allocation: 10.0, value: 52000000, shares: 520000, price: 100.00, change: 3.85, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'VC-FINTECH', name: 'Fintech Ventures Fund III', allocation: 8.0, value: 41600000, shares: 416000, price: 100.00, change: 2.95, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'VC-WEB3', name: 'Web3 Innovation Fund', allocation: 7.0, value: 36400000, shares: 364000, price: 100.00, change: 4.25, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'PE-GROWTH1', name: 'Tiger Global Private Investment', allocation: 12.0, value: 62400000, shares: 624000, price: 100.00, change: 2.75, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'PE-TECH-LATE', name: 'Insight Partners Fund XII', allocation: 8.0, value: 41600000, shares: 416000, price: 100.00, change: 2.45, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'REIT-GROWTH', name: 'High-Growth REIT Fund', allocation: 6.0, value: 31200000, shares: 312000, price: 100.00, change: 1.85, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'REIT-TECH2', name: 'Tech-Focused REIT Portfolio', allocation: 4.0, value: 20800000, shares: 208000, price: 100.00, change: 1.95, sector: 'Real Estate', assetClass: 'Real Estate' },
      { symbol: 'CRYPTO-AGGR', name: 'Aggressive Crypto Portfolio', allocation: 10.0, value: 52000000, shares: 520000, price: 100.00, change: 5.50, sector: 'Digital Assets', assetClass: 'Alternatives' }
    ]
  },
  {
    id: 'nebula',
    name: 'Nebula',
    category: 'Alt-Heavy',
    description: 'Alternative-focused strategy emphasising venture capital, private equity, crypto, and emerging technologies for maximum alpha generation.',
    targetReturn: '18-25%',
    performance: '+21.2%',
    liquidity: '25%',
    minInvestment: 1000,
    fee: 1.5,
    successFee: '20% of returns above 13%',
    riskLevel: 'Very Aggressive',
    icon: 'Sparkles',
    totalAssets: 450000000,
    allocation: [
      { category: 'Venture Capital', percentage: 30 },
      { category: 'Private Equity', percentage: 25 },
      { category: 'Crypto & Digital Assets', percentage: 20 },
      { category: 'Equities', percentage: 15 },
      { category: 'Emerging Tech', percentage: 10 }
    ],
    detailedHoldings: [
      { symbol: 'VC-AI-SEED', name: 'AI Seed Stage Fund (Tier S)', allocation: 12.0, value: 54000000, shares: 540000, price: 100.00, change: 5.25, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'VC-QUANTUM', name: 'Quantum Computing Ventures', allocation: 10.0, value: 45000000, shares: 450000, price: 100.00, change: 4.85, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'VC-BIOTECH', name: 'Biotech Innovation Fund', allocation: 8.0, value: 36000000, shares: 360000, price: 100.00, change: 3.95, sector: 'Venture Capital', assetClass: 'Venture Capital' },
      { symbol: 'PE-UNICORN', name: 'Late-Stage Unicorn Fund', allocation: 15.0, value: 67500000, shares: 675000, price: 100.00, change: 3.75, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'PE-FRONTIER', name: 'Frontier Tech Growth Fund', allocation: 10.0, value: 45000000, shares: 450000, price: 100.00, change: 4.25, sector: 'Private Equity', assetClass: 'Private Equity' },
      { symbol: 'BTC-DIRECT', name: 'Bitcoin Direct Holdings', allocation: 8.0, value: 36000000, shares: 360000, price: 100.00, change: 6.50, sector: 'Crypto', assetClass: 'Crypto & Digital Assets' },
      { symbol: 'ETH-DIRECT', name: 'Ethereum Direct Holdings', allocation: 6.0, value: 27000000, shares: 270000, price: 100.00, change: 5.75, sector: 'Crypto', assetClass: 'Crypto & Digital Assets' },
      { symbol: 'DEFI-FUND', name: 'DeFi Protocol Fund', allocation: 6.0, value: 27000000, shares: 270000, price: 100.00, change: 7.25, sector: 'Crypto', assetClass: 'Crypto & Digital Assets' },
      { symbol: 'PLTR', name: 'Palantir Technologies', allocation: 5.0, value: 22500000, shares: 800000, price: 28.13, change: 4.50, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'COIN', name: 'Coinbase Global Inc.', allocation: 4.0, value: 18000000, shares: 93000, price: 193.55, change: 5.50, sector: 'Financial Services', assetClass: 'Equities' },
      { symbol: 'MSTR', name: 'MicroStrategy Inc.', allocation: 3.5, value: 15750000, shares: 37500, price: 420.00, change: 6.75, sector: 'Technology', assetClass: 'Equities' },
      { symbol: 'ARKK', name: 'ARK Innovation ETF', allocation: 2.5, value: 11250000, shares: 235000, price: 47.87, change: 3.25, sector: 'Innovation', assetClass: 'Equities' },
      { symbol: 'SPACE-TECH', name: 'Space Technology Fund', allocation: 5.0, value: 22500000, shares: 225000, price: 100.00, change: 3.95, sector: 'Emerging Tech', assetClass: 'Emerging Tech' },
      { symbol: 'CLIMATE-TECH', name: 'Climate Tech Ventures', allocation: 5.0, value: 22500000, shares: 225000, price: 100.00, change: 4.15, sector: 'Emerging Tech', assetClass: 'Emerging Tech' }
    ]
  }
];

export const caseStudies = [
  {
    id: 1,
    name: 'Sarah',
    role: 'Tech Professional',
    title: 'From high income to real wealth: How we helped a HENWY diversify beyond salary',
    description: 'A tech professional earning $180k was living paycheque to paycheque with minimal savings. We built a diversified portfolio that grew 24% in 18 months.',
    category: 'HENWY Success',
    image: 'lady-left'
  },
  {
    id: 2,
    name: 'Marcus',
    role: 'Medical Specialist',
    title: 'Turning idle cash into $12,000+ annual returns for a busy doctor',
    description: 'A medical specialist had $150,000 sitting in a savings account earning 1.5%. We deployed it into our balanced portfolio generating meaningful returns.',
    category: 'Yield Optimisation',
    image: 'man-thinking'
  },
  {
    id: 3,
    name: 'Emily & James',
    role: 'Professional Couple',
    title: 'Consolidating scattered investments for a dual-income household',
    description: 'A professional couple with eight different investment accounts. We streamlined everything into one platform with better returns and lower fees.',
    category: 'Account Consolidation',
    image: 'soldier'
  }
];

export const features = [
  {
    icon: 'LineChart',
    title: 'Trove clients have historically compounded on average 10.72% annually',
    description: 'Performance represents net annualised return'
  },
  {
    icon: 'Bot',
    title: 'AI-powered portfolio optimisation and rebalancing',
    description: 'Our proprietary AI continuously monitors and optimises your portfolio allocation for maximum risk-adjusted returns'
  },
  {
    icon: 'Unlock',
    title: 'Access to unlisted assets with institutional-grade liquidity solutions',
    description: 'Invest in private equity, venture capital, and alternative assets with our innovative liquidity mechanism'
  },
  {
    icon: 'Smartphone',
    title: '"One tap" access to your wealth with 360° visibility',
    description: 'Complete transparency and control from your mobile device'
  }
];

export const blogPosts = [
  {
    id: 1,
    title: 'The HENWY Wealth Reality: High Earning, Not Wealthy Yet',
    category: 'HENWY Insights',
    author: 'Josh Sprague',
    readTime: '5 MIN READ',
    image: 'https://images.unsplash.com/photo-1564106254-421ab69f98f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMEF1c3RyYWxpYXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3Njg5NTIyMzR8MA&ixlib=rb-4.1.0&q=85',
    excerpt: 'Earning over $150k but still feel broke? You\'re not alone. Understanding the HENWY phenomenon and how to build real wealth.',
    content: `The Australian financial landscape has given rise to a new demographic: HENWYs - High Earning, Not Wealthy Yet. These are professionals earning well above the national average (typically $150,000+ individually or $250,000+ as a household) yet struggling to accumulate meaningful wealth.

## The HENWY Reality

Despite high incomes, HENWYs face unique challenges:
- High taxation reducing take-home pay
- Lifestyle inflation matching income growth
- Limited access to institutional-grade investments
- Time poverty preventing proper wealth management
- Scattered investments across multiple platforms

## Why Income Doesn't Equal Wealth

The gap between high earners and the truly wealthy isn't just about income - it's about asset allocation, investment access, and strategic wealth building. Traditional wealth management has failed HENWYs by either being too expensive (requiring $500k+ minimums) or too basic (robo-advisers with limited asset classes).

## The Trove Solution

Trove was built specifically for HENWYs, offering:
- Institutional-grade diversification starting from $500
- Access to unlisted assets previously reserved for ultra-high net worth individuals
- AI-powered portfolio optimisation
- Transparent fee structures aligned with your success
- One platform for your entire investment portfolio

## From High Income to High Net Worth

The path from HENWY to wealth requires:
1. **Diversification beyond listed equities** - Access to private equity, venture capital, and alternative assets
2. **Strategic asset allocation** - Based on your risk tolerance and investment horizon
3. **Regular rebalancing** - Automated to capture opportunities and manage risk
4. **Tax-efficient investing** - Structured to minimise tax drag on returns
5. **Long-term discipline** - Staying invested through market cycles

The opportunity for HENWYs is significant. With the right strategy and access to institutional-grade investments, high earners can transition from living paycheque to paycheque to building genuine, multi-generational wealth.`
  },
  {
    id: 2,
    title: 'Solving the Liquidity Problem: How Trove Democratises Access to Unlisted Assets',
    category: 'Investment Innovation',
    author: 'Ross Hastings',
    readTime: '4 MIN READ',
    image: 'https://images.unsplash.com/photo-1555517743-e79e2b19004a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxTeWRuZXklMjBBdXN0cmFsaWElMjBjaXR5JTIwc2t5bGluZSUyMGZpbmFuY2lhbCUyMGRpc3RyaWN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc2ODk1MjE2OXww&ixlib=rb-4.1.0&q=85',
    excerpt: 'The liquidity barrier has kept retail investors out of the best-performing asset classes. Here\'s how we\'ve solved it.',
    content: `For decades, the most attractive investment opportunities - private equity, venture capital, pre-IPO companies - have been locked away from everyday investors due to one critical barrier: liquidity.

## The Liquidity Problem

Unlisted assets have historically delivered superior returns compared to public markets. Private equity has outperformed public equities by 3-4% annually over the past 20 years. Venture capital has created more wealth than almost any other asset class. Yet 99% of Australians can't access these investments because:

1. **Lock-up periods** - Traditional PE/VC funds require 7-10 year commitments
2. **High minimums** - Most funds require $250,000+ entry points
3. **No secondary market** - Once invested, your capital is trapped
4. **Accredited investor requirements** - Legal barriers excluding retail investors

## Trove's Innovation

We've developed a proprietary liquidity solution that gives retail investors access to unlisted assets while maintaining flexibility:

### 1. Quarterly Liquidity Windows
Unlike traditional funds with decade-long lockups, Trove portfolios containing unlisted assets offer quarterly redemption windows. Our AI-powered allocation ensures sufficient liquid assets to meet redemptions while maintaining optimal exposure to illiquid, high-return opportunities.

### 2. Blended Portfolio Strategy
Each Trove portfolio strategically blends listed and unlisted assets:
- **Bedrock**: 30% unlisted (private credit, RE debt) + 70% liquid
- **Horizon**: 50% unlisted (PE, VC, alternatives) + 50% liquid  
- **Nebula**: 75% unlisted (VC, crypto, emerging tech) + 25% liquid

This structure allows us to capture the superior returns of unlisted assets while providing reasonable liquidity to clients.

### 3. AI-Driven Rebalancing
Our proprietary AI monitors fund flows and automatically rebalances between liquid and illiquid positions, ensuring:
- Redemptions can be met without forced asset sales
- New capital is deployed optimally across asset classes
- Portfolio performance isn't sacrificed for liquidity needs

### 4. Secondary Market Access
For clients in urgent need of liquidity outside quarterly windows, we're building a secondary marketplace where Trove portfolio units can be traded peer-to-peer at fair market value.

## The Results

By solving the liquidity problem, we've opened up an entirely new universe of investment opportunities for HENWYs:
- Access to pre-IPO companies with 10x potential
- Private credit yielding 8-12% annually
- Venture capital exposure to tomorrow's tech giants
- Real estate debt with defensive characteristics

## The Future of Wealth Building

The democratisation of access to unlisted assets represents a fundamental shift in wealth creation. No longer do you need millions in net worth to invest like institutions. With Trove, HENWYs can build truly diversified portfolios spanning public and private markets, accelerating their journey from high income to high net worth.

The liquidity problem that has held back retail investors for generations has been solved. The question now is: will you take advantage of it?`
  },
  {
    id: 3,
    title: 'AI in Wealth Management: How Technology Outperforms Human Portfolio Managers',
    category: 'Technology',
    author: 'Matt Taylor',
    readTime: '6 MIN READ',
    image: 'https://images.unsplash.com/photo-1592574209579-4bb00bdb4770?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxNZWxib3VybmUlMjBBdXN0cmFsaWElMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMG9mZmljZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3Njg5NTIxNzF8MA&ixlib=rb-4.1.0&q=85',
    excerpt: 'Trove\'s AI-powered investment engine analyses millions of data points to optimise your portfolio 24/7.',
    content: `Traditional wealth management relies on periodic portfolio reviews - typically quarterly or annually. By the time your adviser gets around to rebalancing your portfolio, market opportunities have often passed. Trove's AI changes this paradigm entirely.

## The Limitations of Human Portfolio Management

1. **Limited processing capacity** - Humans can track dozens of variables; AI tracks millions
2. **Emotional bias** - Fear and greed cloud judgement; algorithms are emotionless
3. **Time constraints** - Advisers manage hundreds of clients; AI monitors 24/7
4. **Slow decision-making** - Committee meetings and approvals delay action

## Trove's AI Advantage

Our proprietary AI investment engine:

### Real-Time Portfolio Optimisation
- Continuously monitors over 10,000 market signals
- Analyses correlations across asset classes
- Identifies rebalancing opportunities milliseconds after they emerge
- Executes trades at optimal moments to maximise returns

### Predictive Risk Management
- Machine learning models predict market volatility
- Automatically adjusts portfolio risk exposure
- Protects downside during market stress
- Captures upside during bull markets

### Personalised to Your Goals
- Learns from your risk tolerance and investment timeline
- Adapts strategy as your circumstances change
- Optimises tax efficiency based on your situation
- Aligns with your specific wealth-building objectives

## The Performance Difference

In backtesting across market cycles, our AI-managed portfolios have:
- Outperformed human-managed portfolios by 2.3% annually
- Reduced drawdowns by 18% during market corrections
- Captured 94% of bull market upside vs. 76% for human managers
- Reduced portfolio volatility by 12%

## The Future Is Automated

AI doesn't replace human judgement entirely - our investment team sets strategic parameters and oversees the AI. But for tactical execution, rebalancing, and continuous optimisation, algorithms simply perform better.

For HENWYs looking to maximise returns while minimising fees, AI-powered wealth management isn't the future - it's the present. And it's only getting better.`
  },
  {
    id: 4,
    title: 'Understanding Market Volatility in 2025',
    category: 'Market Analysis',
    author: 'Dan East',
    readTime: '4 MIN READ',
    image: 'https://images.unsplash.com/photo-1609818969409-5e3635798089?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxTeWRuZXklMjBBdXN0cmFsaWElMjBjaXR5JTIwc2t5bGluZSUyMGZpbmFuY2lhbCUyMGRpc3RyaWN0fGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc2ODk1MjE2OXww&ixlib=rb-4.1.0&q=85',
    excerpt: 'Navigate market uncertainty with confidence and strategy.',
    content: `Market volatility is an inevitable part of investing, yet it remains one of the primary sources of anxiety for investors. Understanding what drives volatility and how to position your portfolio accordingly is crucial for long-term wealth building.

## What's Driving Volatility in 2025?

Several factors are contributing to heightened market uncertainty:

1. **Interest Rate Uncertainty** - Central banks worldwide are navigating the delicate balance between controlling inflation and supporting economic growth. The RBA's rate decisions continue to create ripple effects across all asset classes.

2. **Geopolitical Tensions** - From trade disputes to regional conflicts, global political instability creates market uncertainty. Australian investors with international exposure are particularly affected.

3. **Technology Disruption** - AI and automation are reshaping industries faster than ever, creating winners and losers across sectors. Traditional business models are being challenged, creating both opportunity and risk.

4. **Climate Transition** - The shift to renewable energy is accelerating, impacting everything from mining stocks to property values in climate-vulnerable areas.

## The Emotional Trap

The biggest threat to your wealth isn't volatility itself—it's how you react to it. Studies consistently show that investors who panic-sell during downturns and chase returns during rallies significantly underperform those who stay disciplined.

Consider this: missing just the 10 best trading days over a 20-year period can cut your returns in half. And those best days often occur immediately after the worst days, when emotions run highest.

## Strategies for Volatile Markets

### 1. Diversification Across Asset Classes

Don't put all your eggs in one basket. A well-diversified portfolio should include:
- **Equities** for growth potential
- **Bonds** for stability and income
- **Real estate** for inflation protection
- **Alternative assets** for uncorrelated returns

### 2. Rebalancing

Regular rebalancing forces you to sell high and buy low systematically, removing emotion from the equation.

### 3. Dollar-Cost Averaging

Investing a fixed amount regularly, regardless of market conditions, smooths out the impact of volatility over time.

### 4. Quality Over Speculation

In volatile markets, quality companies with strong balance sheets and sustainable competitive advantages tend to outperform speculative investments.

## The Trove Approach

At Trove, our AI-powered platform continuously monitors volatility across all asset classes and automatically adjusts your portfolio to maintain optimal risk exposure. We don't try to time the market—instead, we focus on:

- Maintaining your target asset allocation through automated rebalancing
- Identifying opportunities when quality assets become undervalued
- Protecting downside through strategic diversification
- Keeping you invested through market cycles

## Embracing Volatility

Rather than fearing volatility, view it as the price of admission to superior long-term returns. The equity risk premium—the additional return stocks provide over bonds—exists precisely because of this volatility. Without it, everyone would invest in stocks, driving down expected returns.

The key is positioning your portfolio to weather volatility while remaining invested for the long term. That's where having a disciplined investment strategy and the right technology partner becomes invaluable.

Market volatility in 2025 isn't something to fear—it's something to understand and strategically navigate. With the right approach, volatile markets create opportunities for disciplined investors to build wealth while others react emotionally and underperform.`
  },
  {
    id: 5,
    title: 'Tax-Efficient Investing for High Earners',
    category: 'Tax Strategy',
    author: 'Josh Sprague',
    readTime: '5 MIN READ',
    image: 'https://images.unsplash.com/photo-1614368240409-365a7eee1c7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxNZWxib3VybmUlMjBBdXN0cmFsaWElMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMG9mZmljZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3Njg5NTIxNzF8MA&ixlib=rb-4.1.0&q=85',
    excerpt: 'Maximise your after-tax returns with strategic investment structuring.',
    content: `For high-income Australians, taxes can be the single largest drag on investment returns. At the top marginal rate of 47% (including Medicare levy), nearly half of your investment income goes to the ATO. Strategic tax planning isn't about avoidance—it's about intelligent structuring to maximise your after-tax wealth.

## Understanding Your Tax Position

Before optimising, understand where you stand:

- **Marginal Tax Rate**: Income over $190,000 is taxed at 45% (+2% Medicare levy)
- **Capital Gains**: 50% discount available on assets held 12+ months
- **Dividend Imputation**: Franking credits reduce tax on Australian dividends
- **Superannuation**: Concessional contributions taxed at just 15%

## Key Strategies for HENWYs

### 1. Maximise Superannuation Contributions

The super system remains Australia's most powerful wealth-building vehicle for high earners:

- **Concessional contributions** (up to $30,000/year): Taxed at just 15% vs your marginal rate
- **Tax savings**: A $30,000 contribution saves $9,600 in tax for someone on the top marginal rate
- **Division 293 tax**: High earners pay an additional 15% on super contributions, but 30% is still better than 47%

### 2. Investment Structure Optimisation

How you hold investments matters as much as what you hold:

**Individual Name**
- Simple and flexible
- Full marginal rate on income
- Best for: Negatively geared investments, assets with expected losses

**Family Trust**
- Income can be distributed to lower-income beneficiaries
- Retained earnings taxed at up to 47%
- Best for: Families with income disparity, asset protection needs

**Company Structure**
- Flat 25-30% tax rate on retained earnings
- Access to funds requires dividends (additional tax)
- Best for: Accumulating business/investment wealth long-term

**SMSF**
- 15% tax on income, 10% on long-term capital gains, 0% in pension phase
- Limited access until preservation age
- Best for: Long-term retirement wealth

### 3. Asset Location Strategy

Not all investments are equal from a tax perspective. Match investments to the most tax-efficient structure:

| Investment Type | Best Structure | Why |
|----------------|----------------|-----|
| High-yield bonds | Super | Income taxed at 15% |
| Growth shares | Personal/Trust | CGT discount, franking credits |
| International shares | Super | No franking, benefits from lower rate |
| Property | Trust/Personal | Negative gearing benefits |

### 4. Timing Your Gains

Strategic timing of capital gains can save thousands:

- **Defer gains** to lower-income years (sabbatical, career change)
- **Realise losses** to offset gains in the same financial year
- **Hold for 12+ months** to access the 50% CGT discount
- **Consider timing around 30 June** to defer tax by 12+ months

### 5. Debt Recycling

Convert non-deductible debt (home loan) into deductible debt (investment loan):

1. Pay extra into your home loan offset account
2. Borrow the same amount to invest
3. Investment loan interest is tax-deductible
4. Over time, your non-deductible debt converts to deductible debt

## The Compounding Impact

Let's illustrate the power of tax-efficient investing:

**Scenario**: $100,000 invested, 8% return, 20-year horizon

| Approach | After-Tax Return | 20-Year Value |
|----------|------------------|---------------|
| No optimisation (47% tax) | 4.24% | $229,891 |
| Super (15% tax) | 6.80% | $370,963 |
| **Tax-efficient mix** | **5.80%** | **$308,165** |

The difference: **$78,274** more wealth from tax efficiency alone.

## Common Mistakes to Avoid

1. **Over-complicating structures** - Compliance costs can outweigh benefits
2. **Ignoring Division 293** - Factor in the additional 15% super tax
3. **Forgetting estate planning** - Tax-efficient in life, but what about death?
4. **Chasing deductions over returns** - A good investment beats a tax deduction

## The Trove Approach

We build tax awareness into every portfolio decision:

- Asset location recommendations based on your structure
- Automated tax-loss harvesting to offset gains
- Franking credit optimisation for Australian allocations
- Regular reviews aligned with tax planning opportunities

Tax-efficient investing isn't a one-time decision—it's an ongoing strategy that evolves with your circumstances. For HENWYs serious about building wealth, it's one of the highest-impact levers available.`
  },
  {
    id: 6,
    title: 'Building Wealth in Your 30s and 40s',
    category: 'Wealth Building',
    author: 'Ross Hastings',
    readTime: '5 MIN READ',
    image: 'https://images.unsplash.com/photo-1595779757577-5252b71ce75b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxNZWxib3VybmUlMjBBdXN0cmFsaWElMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMG9mZmljZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3Njg5NTIxNzF8MA&ixlib=rb-4.1.0&q=85',
    excerpt: 'The critical decade for HENWYs to transition from high income to high net worth.',
    content: `Your 30s and 40s represent the most critical period for wealth building. It's when careers peak, earning potential maximises, and the decisions you make compound dramatically over time. Yet for many HENWYs, these decades slip by with little to show beyond lifestyle inflation and scattered investments.

## The HENWY Trap in Your Prime Years

If you're earning $200,000+ but your net worth hasn't kept pace, you're not alone. The typical HENWY in their 30s and 40s faces:

- **Peak lifestyle costs**: Mortgage, private schools, premium experiences
- **Career demands**: No time to manage investments properly
- **Competing priorities**: Kids' activities, aging parents, career advancement
- **Lifestyle creep**: Each raise gets absorbed by upgraded living standards

The result? High earners who should be building serious wealth are instead running on a treadmill.

## The Wealth-Building Window

Here's the uncomfortable truth: if you haven't built substantial wealth by 50, the math gets increasingly difficult. Let's look at why your 30s and 40s matter so much:

**Starting at 35 vs 45** (investing $50,000/year at 8% return):

| Start Age | Wealth at 60 | Total Invested |
|-----------|--------------|----------------|
| 35 | $3,425,685 | $1,250,000 |
| 45 | $1,214,663 | $750,000 |

Starting just 10 years earlier results in **$2.2 million more wealth** despite only $500,000 more invested. That's the power of compound growth—but it requires starting now.

## The Five Pillars of HENWY Wealth Building

### 1. Close the Gap Between Income and Spending

The first rule of wealth building: spend less than you earn. For HENWYs, this often means:

- **Audit your lifestyle inflation** - Is every upgrade truly worth it?
- **Set a savings rate target** - Aim for 20-30% of gross income
- **Automate savings** - Pay yourself first, before lifestyle spending
- **Question "normal"** - Private schools, new cars, overseas holidays—do they align with your values?

### 2. Optimise Your Career Capital

Your earning potential is your biggest asset. Maximise it:

- **Invest in skills** that increase your value
- **Build your network** strategically
- **Negotiate compensation** - Most HENWYs leave money on the table
- **Consider equity** - Startups and growth companies offer wealth acceleration opportunities

### 3. Build an Investment Machine

Stop treating investing as an afterthought:

- **Consolidate scattered investments** into a coherent strategy
- **Diversify beyond Australian equities** - Most HENWYs are over-exposed to local markets
- **Access alternative assets** - Private equity, venture capital, and real estate debt offer superior risk-adjusted returns
- **Automate and systematise** - Remove emotion and inconsistency from investing

### 4. Leverage Tax Structures

High earners have the most to gain from tax optimisation:

- **Max super contributions** - The tax savings alone are worth it
- **Consider investment structures** - Trusts, companies, and SMSFs each have their place
- **Think long-term on capital gains** - The 50% discount rewards patience

### 5. Protect Your Wealth Machine

Don't let unexpected events derail your progress:

- **Appropriate insurance** - Income protection, life, TPD
- **Estate planning** - Wills, powers of attorney, binding death nominations
- **Asset protection** - Structure investments to protect from business/professional risks

## The Psychology of Wealth Building

Building wealth in your peak earning years requires psychological shifts:

### From Consumer to Owner

Stop buying things; start buying assets. Every dollar spent on consumption is a dollar not compounding for your future. Ask: "Am I buying lifestyle or building wealth?"

### From Instant to Delayed Gratification

The HENWY lifestyle is built on instant gratification. Wealth is built on delayed gratification. Finding joy in your growing portfolio rather than your growing possessions is a mindset shift that changes everything.

### From Comparison to Personal Goals

Your wealthy-looking neighbours might be one redundancy away from financial stress. Focus on your own journey, not keeping up appearances.

## The 10-Year Transformation

Imagine applying these principles consistently for 10 years:

**Starting Point** (Age 35):
- Income: $250,000
- Net Worth: $200,000 (mostly home equity)
- Savings Rate: 10%

**After Optimisation** (Age 45):
- Income: $350,000 (career capital growth)
- Savings Rate: 25%
- Invested: $875,000 over 10 years
- Net Worth: $1,400,000+ (investment growth + home equity)

This isn't fantasy—it's the result of applying these principles consistently over a decade. The HENWYs who make this transition are the ones who treat wealth building with the same seriousness as their careers.

## Take Action Now

The best time to start was 10 years ago. The second best time is today. Every year of delay costs you more than you realise.

At Trove, we've built a platform specifically for HENWYs ready to make this transition. Institutional-grade portfolios, AI-powered optimisation, and access to alternative assets—all designed to help high earners become high net worth.

Your 30s and 40s will pass regardless. The only question is: will you be wealthier at the end of them?`
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Josh Sprague',
    role: 'CEO & Co-Founder',
    bio: 'CPO at Selfwealth (leading retail investing platform). 15+ years B2C fintech across capital markets, equities and alt investments. Transformed and led a $16 Billion+ AUM platform, with deep expertise in regulatory change management.',
    image: '/team-photos/josh-sprague.png'
  },
  {
    id: 2,
    name: 'Ross Hastings',
    role: 'CMO & Co-Founder',
    bio: 'Expert in organisational psychology and behavioural economics to develop high performance cultures & standout brands. Co-founder of Ne-Lo Business Design & Timebirds, Co-creator of The Anatomy of Marketing & The Purpose Framework, MAICD, Global Scot, and Editorial Board Member on 2 prominent psychology journals.',
    image: '/team-photos/ross-hastings.png'
  },
  {
    id: 3,
    name: 'Dan East',
    role: 'CIO - Chief Investment Officer',
    bio: 'Dan has over 35 years experience in global markets and specialises in developing customised portfolios of high-quality assets that align with well-defined goals, including incorporating negative screening, positive tilts, and identifying impact assets. Dan\'s comprehensive financial markets experience encompasses equities, money markets, currencies, fixed interest and derivatives in the European, US and domestic markets.',
    image: '/team-photos/dan-east.png'
  },
  {
    id: 4,
    name: 'Matt Taylor',
    role: 'CFO',
    bio: 'As a CA, Accredited Financial Planner and broker, Matt has strong experience a range of complex tax matters, business growth strategies including, and M&A advisory. As well as financial services, investment, and tech sectors, he has expertise across startups and SMEs in manufacturing, professional services, medical, property, retail, wholesale, NFPs, and hospitality giving him a broad perspective and experience base to draw from.',
    image: '/team-photos/matt-taylor.png'
  }
];

export const portfolioData = {
  totalValue: 125750.32,
  totalGain: 25750.32,
  totalGainPercent: 25.75,
  dayChange: 1250.45,
  dayChangePercent: 1.02,
  holdings: [
    {
      id: 1,
      strategyId: 'velocity',
      name: 'Velocity',
      value: 65000,
      shares: 1000,
      gain: 15000,
      gainPercent: 30.0,
      allocation: 51.7
    },
    {
      id: 2,
      strategyId: 'horizon',
      name: 'Horizon',
      value: 35000,
      shares: 500,
      gain: 7000,
      gainPercent: 25.0,
      allocation: 27.8
    },
    {
      id: 3,
      strategyId: 'bedrock',
      name: 'Bedrock',
      value: 25750.32,
      shares: 2575,
      gain: 3750.32,
      gainPercent: 17.04,
      allocation: 20.5
    }
  ],
  performanceHistory: [
    { month: 'Jan', value: 100000 },
    { month: 'Feb', value: 103000 },
    { month: 'Mar', value: 107000 },
    { month: 'Apr', value: 105000 },
    { month: 'May', value: 110000 },
    { month: 'Jun', value: 115000 },
    { month: 'Jul', value: 118000 },
    { month: 'Aug', value: 120000 },
    { month: 'Sep', value: 122000 },
    { month: 'Oct', value: 123500 },
    { month: 'Nov', value: 124000 },
    { month: 'Dec', value: 125750.32 }
  ]
};

export const marketData = {
  indices: [
    { name: 'ASX 200', value: 7845.23, change: 45.67, changePercent: 0.59 },
    { name: 'S&P 500', value: 4783.45, change: 12.34, changePercent: 0.26 },
    { name: 'NASDAQ', value: 15235.78, change: -23.45, changePercent: -0.15 },
    { name: 'FTSE 100', value: 7689.12, change: 34.56, changePercent: 0.45 }
  ],
  lastUpdated: new Date().toISOString()
};